export function getLocalizedNameByLocale(locale?: string) {
  if (!locale) return '';
  return (
    new Intl.DisplayNames([locale], { type: 'language' }).of(locale) || locale
  );
}
